import NProgress from "nprogress";
import router from "../index";
import { setRemConfig } from "@/config/rem";

export function createRouteGuard() {
  router.beforeEach(async (to, from, next) => {
    NProgress.configure({ showSpinner: false });
    setRemConfig(to?.meta?.rem);
    document.title = to.meta.title;
    NProgress.start();
    next()
  });
  // 路由加载后
  router.afterEach(() => {
    NProgress.done();
  });

}
